<template>
  <el-card class="box-card">
    <common-el-form
      :model="model"
      :submitData="submitData"
      @success="onSuccess"
      ref="model"
      :showButton="false"
      :inline="true"
      :SubmitButton="true"
      submit-btn-text="查询"
      failTitle="提交失败"
      loadingText="提交中..."
      :submitService="submitService"
    >
      <p class="commonTitle">团队激活机具查询</p>
      <div style="display: flex; align-items: center">
        <el-form-item :rules="userId" label="代理商ID" prop="userId">
          <el-input v-model="model.userId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item
          label="硬件产品类型"
          prop="hardwareType"
          :rules="hardwareType"
        >
          <el-select v-model="model.hardwareType">
            <el-option
              v-for="item in hardwareTypeStatus"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>结果：{{ jieguo }}</el-form-item>
      </div>
    </common-el-form>
  </el-card>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";

import SystemDicService from "service/SystemDicService";
import PosService from "service/PosService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "foundermanage",
  props: {
    isReload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitService: SystemDicService.jhLIst,
      model: {
        userId: "",
        hardwareType: "",
      },
      jieguo: "",
      hardwareTypeStatus: [],
      userId: {
        required: true,
        message: "请输入",
      },
      hardwareType: {
        required: true,
        message: "请选择",
      },
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonElForm,
  },
  mounted() {
    this.gethardwareTypeStatus();
  },
  watch: {},
  computed: {
    submitData() {
      const params = {
        userId: this.model.userId,
        hardwareType: this.model.hardwareType,
      };
      return params;
    },
    // ...mapGetters(["userId", "orgDetail"]),
  },
  methods: {
    gethardwareTypeStatus() {
      //硬件产品类型
      this.doLoad(
        PosService.posYingJianType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareTypeStatus = [
              ...this.hardwareTypeStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.jieguo = res.contents;
      this.showSuccess(res.respMsg);
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/fragment/select/JHSelect.vue